import apiArmada from '@/api/logistic/armada';

const defaultState = () => ({
	listArmada: [],
	detailArmada: {},
	armadaPagination: '',
	responSukses: {},
	responseError: {},
	konfirmResponse: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {};

const mutations = {
	setArmada(state, data) {
		state.listArmada = data.data;
		state.armadaPagination = data.pagination;
	},
	setDetailArmada(state, data) {
		state.detailArmada = data
	},
	saveResponseError(state, data) {
		state.responseError = data;
	},
	saveResponse(state, data) {
		state.responSukses = data
		state.responseError = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
};

const actions = {
	getArmada({ commit }, params) {
		apiArmada.getArmada(params).then(({ data: { data } }) => {
			commit('setArmada', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('setArmada', { data: [], pagination: {} });
		});
	},
	getDetailArmada({ commit, dispatch }, params) {
		apiArmada.getDetailArmada(params).then(({ data: { data } }) => {
			commit('setDetailArmada', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailArmada', { data: [] });
		});
	},
	async addArmada({ dispatch, commit }, value) {
		await dispatch('isAttempting', null, { root: true })
		await apiArmada.addArmada(value).then( res => {
			const data = res.data;
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data
			commit("saveResponseError", data);
			dispatch("errorHandler", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal tambah armada'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async editArmada({ dispatch, commit }, value) {
		await dispatch('isAttempting', null, { root: true })
		await apiArmada.editArmada(value).then( res => {
			const data = res.data;
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data
			commit("saveResponseError", data);
			dispatch("errorHandler", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal tambah armada'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async deleteArmada({ dispatch, commit }, value) {
		await apiArmada.deleteArmada({ id: value }).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menghapus data armada'
			}, { root: true });
		});
	},
	async statusArmada({ dispatch, commit }, value) {
		await dispatch('isAttempting', null, { root: true })
		await apiArmada.statusArmada(value).then( res => {
			const data = res.data;
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data
			commit("saveResponseError", data);
			dispatch("errorHandler", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal ubah status armada'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};